window.__ENV__ = import.meta.env.MODE;
